export default __webpack_public_path__ + "static/media/welcom-card.19b8b2de.svg";